<template>
    <div>
        <Frame
            v-model:isOpen="isOpen"
            :title="title"
            button-position="mt-2.5 md:mt-3.5"
            @resetValues="cancelChange"
        >
            <template #data>
                <slot name="subtitle">
                    <div
                        v-if="subtitle"
                        class="pb-2.5 text-base md:text-lg text-black font-bold border-bottom"
                    >
                        {{ subtitle }}
                    </div>
                    <p class="text-black text-base font-bold mb-4">
                        <template v-if="isAplCatlA5()">
                            要保人： {{ showData.beneFiName }}
                        </template>
                        <template v-else-if="isAplCatlA6()">
                            給付對象： {{ showData.beneFiName }}
                        </template>
                        <template v-else>
                            受益人： {{ showData.beneFiName }}
                        </template>
                    </p>
                </slot>
                <div class="md:relative">
                    <div class="hidden md:block">
                        <div class="h-[2.5rem] gradient-primary md:rounded-t" />
                        <div ref="layer" />
                    </div>
                    <div
                        ref="dataBox"
                        class="dataBox"
                    >
                        <div class="flex py-2.5 md:py-0 md:block border-bottom md:col-span-2">
                            <div class="title whitespace-nowrap">
                                <template v-if="isAplCatlA5()">
                                    要保人ID
                                </template>
                                <template v-else-if="isAplCatlA6()">
                                    給付對象ID
                                </template>
                                <template v-else>
                                    受益人ID
                                </template>
                            </div>
                            <div class="text-lg md:px-4 md:py-2 break-all">
                                <template v-if="isAplCatlA5()">
                                    {{ showData.beneFiId ? showData.beneFiId : '未留存ID' }}
                                </template>
                                <template v-else>
                                    {{ showData.beneFiId ? showData.beneFiId : '未留存ID' }}
                                </template>
                            </div>
                        </div>
                        <div
                            v-if="showData.foreignAccount"
                            class="flex py-2.5 md:py-0 md:block md:col-span-3 border-bottom"
                        >
                            <div class="title">
                                英文戶名
                            </div>
                            <div class="text-lg md:px-4 md:py-2 break-all">
                                {{ showData.bankAccountName ? showData.bankAccountName : '未指定' }}
                            </div>
                        </div>
                        <div
                            class="flex py-2.5 md:py-0 md:block border-bottom"
                            :class="[showData.foreignAccount?'md:col-span-3':'md:col-span-6']"
                        >
                            <div class="title">
                                銀行
                            </div>
                            <div class="text-lg md:px-4 md:py-2 break-all">
                                <div v-if="showData.headBankNo">
                                    <div>{{ showData.headBankNo }}{{ showData.branchBankNo }} </div>
                                    <!-- <div>{{ showData.headBankName }} {{ showData.branchBankName }}</div> -->
                                    <div>{{ showData.headBankName }}</div>
                                </div>
                                <p v-else>
                                    未指定
                                </p>
                            </div>
                        </div>
                        <div
                            class="flex py-2.5 md:py-0 md:block md:col-span-3"
                            :class="{'border-bottom':!isOpen}"
                        >
                            <div class="title">
                                帳號
                            </div>
                            <div class="text-lg md:px-4 md:py-2 break-all">
                                {{ showData.bankAccount ? showData.bankAccount : '未指定' }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #inputs>
                <div class="md:grid md:grid-cols-11 md:gap-4">
                    <div
                        class="flex md:block border-bottom pb-2.5 "
                        :class="[showData.foreignAccount?'md:col-span-2 mt-0 md:mt-2.5 md:py-2.5':'md:col-span-2']"
                    >
                        <div class="flex-shrink-0 text-sm text-gray-900 mr-1 md:hidden w-[4.5rem]">
                            <span class="title-leading">
                                <template v-if="isAplCatlA5()">
                                    要保人ID
                                </template>
                                <template v-else-if="isAplCatlA6()">
                                    給付對象ID
                                </template>
                                <template v-else>
                                    受益人ID
                                </template>
                            </span>
                        </div>
                        <template v-if="isAplCatlA5()">
                            <div class="w-full input-max-width md:max-w-none">
                                <div class="text-lg break-all">
                                    {{ showData.beneFiId ? showData.beneFiId : '未留存' }}
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div
                                v-if="!showData.beneFiId"
                                class="w-full input-max-width md:max-w-none"
                            >
                                <input
                                    v-model.trim="userData.beneFiId"
                                    name="beneFiId"
                                    type="text"
                                    class="input-base"
                                    placeholder="請輸入受益人ID"
                                    autocomplete="off"
                                    inputmode="numeric"
                                    @input="validateBeneFiId"
                                >
                                <!-- :disabled="showData.foreignAccount? !userData.headBankNo :!userData.branchBankNo" -->
                                <p class="error-msg text-right">
                                    {{ userData.errorMessage.beneFiId }}
                                </p>
                            </div>
                            <div
                                v-else
                                class="w-full input-max-width md:max-w-none"
                            >
                                <div class="text-lg break-all">
                                    {{ showData.beneFiId }}
                                </div>
                            </div>
                        </template>
                    </div>
                    <div
                        v-if="showData.foreignAccount"
                        class="flex pb-2.5 md:pb-0 border-bottom md:block md:col-span-3"
                    >
                        <div class="flex-shrink-0 text-sm text-gray-900 mr-1 md:hidden w-[4.5rem] self-center">
                            <span :class="[showData.foreignAccount?'title-leading':'leading-7']">
                                英文戶名
                            </span>
                        </div>
                        <div
                            v-if="showData.foreignAccount"
                            class="w-full input-max-width md:max-w-none"
                        >
                            <ul class="text-tip mt-3 md:mt-0 mb-1 md:h-[1rem]">
                                <li class="text-sm p-0 m-0 md:whitespace-nowrap">
                                    請輸入存摺或護照之英文譯音
                                </li>
                            </ul>
                            <input
                                v-model.trim="userData.bankAccountName"
                                name="bankAccountName"
                                type="text"
                                class="input-base w-full"
                                placeholder="請輸入銀行戶名"
                                autocomplete="off"
                                @input="validateBankAccountName"
                            >
                            <p class="error-msg text-right">
                                {{ userData.errorMessage.bankAccountName }}
                            </p>
                        </div>
                        <div
                            v-else
                            class="text-lg break-all md:pt-2.5"
                        >
                            {{ showData.bankAccountName }}
                        </div>
                    </div>
                    <div
                        class="flex py-2.5 md:py-0 border-bottom md:block"
                        :class="[showData.foreignAccount?'mt-0 md:mt-5 md:col-span-3':' md:col-span-6']"
                    >
                        <div class="flex-shrink-0 text-sm text-gray-900 mr-1 align-top md:hidden w-[4.5rem]">
                            <span class="title-leading">
                                銀行
                            </span>
                        </div>
                        <div
                            class="w-full"
                            :class="{'lg:flex':!showData.foreignAccount}"
                        >
                            <div
                                class="input-max-width"
                                :class="[showData.foreignAccount?'md:max-w-none':'lg:w-1/2 mb-2.5 lg:mb-0 lg:mr-2.5']"
                            >
                                <Multiselect
                                    v-model="userData.headBankNo"
                                    :options="bankOptions"
                                    :can-clear="false"
                                    :can-deselect="false"
                                    :disabled="showData.foreignAccount ? !userData.bankAccountName : false"
                                    mode="single"
                                    placeholder="請選擇銀行"
                                    class="select-base"
                                    label="label"
                                    no-options-text="查無銀行"
                                    no-results-text="查無結果"
                                    searchable
                                    @select="reloadBranch()"
                                />
                                <p class="error-msg text-right">
                                    {{ userData.errorMessage.headBankNo }}
                                </p>
                            </div>
                            <div
                                v-if="!showData.foreignAccount"
                                class="input-max-width lg:w-1/2"
                            >
                                <Multiselect
                                    v-model="userData.branchBankNo"
                                    :options="branchOptions"
                                    :can-clear="false"
                                    :can-deselect="false"
                                    :disabled="!userData.headBankNo"
                                    mode="single"
                                    placeholder="請選擇分行"
                                    label="bankName"
                                    no-options-text="查無分行"
                                    no-results-text="查無結果"
                                    class="select-base"
                                    searchable
                                    @select="userData.errorMessage.branchBankNo = ''"
                                />
                                <p class="error-msg text-right">
                                    {{ userData.errorMessage.branchBankNo }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="flex py-2.5 md:block md:py-0 border-bottom md:col-span-3"
                        :class="[showData.foreignAccount?'mt-0 md:mt-5 ':'']"
                    >
                        <div class="flex-shrink-0 text-sm text-gray-900 mr-1 md:hidden w-[4.5rem]">
                            <span class="title-leading">帳號</span>
                        </div>
                        <div class="w-full input-max-width md:max-w-none">
                            <input
                                v-model.trim="userData.bankAccount"
                                name="bankAccount"
                                type="text"
                                class="input-base"
                                placeholder="請輸入帳號"
                                autocomplete="off"
                                inputmode="numeric"
                                :disabled="showData.foreignAccount? !userData.headBankNo :!userData.branchBankNo"
                                @input="validateBankAccount"
                            >
                            <p class="error-msg text-right">
                                {{ userData.errorMessage.bankAccount }}
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </Frame>
        <!-- 後端驗證錯誤訊息燈箱 -->
        <PopupBase v-model:visiblePopup="visiblePopup">
            <template #title>
                請調整資料格式
            </template>
            <template #content>
                <ul v-if="errorTip.length !== 0">
                    <li>
                        {{ errorTip }}
                    </li>
                </ul>
                <ul
                    v-if="errorResponse.length>0"
                    class="space-y-2 list-decimal ml-6"
                >
                    <li
                        v-for="(item, index) in errorResponse"
                        :key="index"
                    >
                        <p>
                            {{ `${fieldNameList[item.field]}${item.value||''}` }}
                        </p>
                        <p class="text-error text-sm">
                            {{ item.errorMessage }}
                        </p>
                    </li>
                </ul>
            </template>
            <template #action>
                <button
                    class="btn gradient-primary rounded-full"
                    @click="closePopup"
                >
                    確定
                </button>
            </template>
        </PopupBase>
    </div>
</template>

<script>
import { onMounted, ref, toRef, toRefs, watch, watchEffect } from 'vue';
import { useResizeObserver, useWindowSize } from '@vueuse/core';
import { integer, englishName } from '@/utils/rules/customRules';
import Frame from '@/components/collapse/CollapseFrame.vue';
import Multiselect from '@vueform/multiselect';
import PopupBase from '@/components/dialogs/Popup.vue';
import { EUDC } from '@/utils/EUDC';
import { isAplCatlA5, isAplCatlA6 } from '@/utils/is/aplCatlUtils.js';

export default {
    components: {
        Frame,
        Multiselect,
        PopupBase
    },
    props: {
        isOpenChange: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        dataBase: {
            type: Object,
            default: () => { }
        },
        data: {
            type: Object,
            default: () => { }
        },
        bankOptions: {
            type: Array,
            default: () => []
        },
        branchOptions: {
            type: Array,
            default: () => []
        },
        validInput: {
            type: Boolean,
            default: false
        },
        errorResponse: {
            type: Array,
            default: () => []
        },
    },
    emits: ['update:isOpenChange', 'getBranchOptions', 'update:validInput', 'getValidResult', 'update:errorResponse'],
    setup(props, { emit }) {
        const { width } = useWindowSize();
        const dataBox = ref(null);
        const layer = ref(null);
        const showData = toRef(props, 'dataBase');
        const userData = toRef(props, 'data');
        const isOpen = ref(false);
        const { validInput } = toRefs(props);
        const visiblePopup = ref(false);
        const errorTip = ref('');
        EUDC();
        const fieldNameList = {
            headBankNo: '銀行總行代號',
            branchBankNo: '銀行分行代號',
            bankAccount: '銀行帳戶',
            bankAccountName: '銀行帳戶名'
        };

        onMounted(() => {
            useResizeObserver(dataBox.value, (entries) => {
                const entry = entries[0];
                const { height } = entry.contentRect;
                if (width.value > 780) {
                    layer.value.style.height = height - 40 + 'px';
                }
            });
        });

        const reloadBranch = () => {
            userData.value.branchBankNo = '';
            userData.value.bankAccount = '';
            userData.value.errorMessage.headBankNo = '';
            userData.value.errorMessage.branchBankNo = '';
            userData.value.errorMessage.bankAccount = '';
            // 外幣保單沒有branch
            if (!showData.value.foreignAccount) emit('getBranchOptions', userData.value.headBankNo);
        };

        const validateBankAccountName = () => {
            if (!userData.value.bankAccountName) {
                userData.value.headBankNo = '';
                userData.value.bankAccount = '';
                userData.value.errorMessage.headBankNo = '';
                userData.value.errorMessage.bankAccount = '';
            }
            const msg = englishName(userData.value.bankAccountName);
            userData.value.errorMessage.bankAccountName = msg || '';
        };

        const validateBankAccount = () => {
            const msg = integer(userData.value.bankAccount, '請輸入數字');
            userData.value.errorMessage.bankAccount = msg || '';
        };

        const validateBeneFiId = () => {
            if (!showData.value.beneFiId) {
                const msg = userData.value.beneFiId.length === 0 ? '請輸入受益人ID' : '';
                userData.value.errorMessage.beneFiId = msg || '';
            }
        };

        const cancelChange = () => {
            userData.value.beneFiId = '';
            userData.value.headBankNo = '';
            userData.value.branchBankNo = '';
            userData.value.bankAccount = '';
            userData.value.bankAccountName = '';
            userData.value.errorMessage.headBankNo = '';
            userData.value.errorMessage.branchBankNo = '';
            userData.value.errorMessage.bankAccount = '';
            userData.value.errorMessage.bankAccountName = '';
        };

        const closePopup = () => {
            visiblePopup.value = false;
            errorTip.value = [];
            emit('update:errorResponse', []);
        };

        watchEffect(() => {
            isOpen.value = props.isOpenChange;
            visiblePopup.value = props.errorResponse.length !== 0;
        });

        watch(isOpen, (nV) => {
            emit('update:isOpenChange', nV);
        });

        watch(validInput, (nV) => {
            if (nV) {
                const { headBankNo, branchBankNo, bankAccount, bankAccountName, beneFiId } = userData.value;
                if (showData.value.foreignAccount && !bankAccountName) userData.value.errorMessage.bankAccountName = '請輸入戶名';
                if (!headBankNo) userData.value.errorMessage.headBankNo = '請選擇銀行';
                if (!showData.value.foreignAccount && !branchBankNo) userData.value.errorMessage.branchBankNo = '請選擇分行';
                if (!bankAccount) userData.value.errorMessage.bankAccount = '請輸入帳號';
                if (!showData.value.beneFiId && !beneFiId) userData.value.errorMessage.beneFiId = '請輸入受益人ID';
                const hasError = Object.values(userData.value.errorMessage).some(i => !!i);

                emit('getValidResult', hasError, userData.value);
                emit('update:validInput', false);
            }
        });

        return {
            showData,
            userData,
            layer,
            dataBox,
            isOpen,
            cancelChange,
            errorTip,
            fieldNameList,
            visiblePopup,
            closePopup,
            reloadBranch,
            validateBankAccountName,
            validateBankAccount,
            isAplCatlA5,
            isAplCatlA6,
            validateBeneFiId
        };
    }
};
</script>
<style lang="scss" scoped>
.title {
    @apply flex-shrink-0 text-sm leading-7 w-24 text-gray-400 md:text-base md:text-white md:px-4 md:py-2;
}

.dataBox {
    @apply md:absolute md:top-0 md:right-0 md:left-0 md:grid md:grid-cols-11;
}

.title-leading {
    @apply leading-10 xs:leading-[3rem];
}

.border-bottom {
    @apply border-b border-gray-200 border-dashed md:border-0;
}

.input-max-width {
    @apply max-w-[18.125rem] xs:max-w-[21.875rem];
}
</style>
